/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import ajax from "helpers/ajax";
import {createAction} from "helpers/createAction";
import {DEFAULT_HALL_ID} from "helpers/config";
import {Article} from "types/entities/Article";
import {ArticleType} from "types/enums/ArticleType";
import {ArticleGroup} from "types/entities/ArticleGroup";
import {
    ArticlesReducerSetArticleGroupsAction,
    ArticlesReducerSetArticlesAction,
    ArticlesReducerSetArticlesKioskAction,
} from "store/articles/ArticlesReducer";

class ArticlesAction {
    static SET_ARTICLES = "ArticlesAction.SetArticles";
    static SET_ARTICLES_KIOSK = "ArticlesAction.SetArticlesKiosk";
    static SET_ARTICLE_GROUPS = "ArticlesAction.SetArticleGroups";

    /**
     * Fetch articles public to visitors
     */
    static fetchArticlesWithHall = () => {
        return async dispatch => {
            try {
                const response: {
                    articles: Article[];
                } = await ajax.get("/articles/shop-list?hall_id=" + DEFAULT_HALL_ID);
                dispatch(ArticlesAction.setArticles(response.articles));
                return Promise.resolve(response.articles);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    static fetchArticlesKiosk = () => {
        return async dispatch => {
            try {
                const response: {articles: Article[]} = await ajax.get("/online-venue/shop/list", {
                    params: {
                        type: ArticleType.Kiosk,
                        hall_id: DEFAULT_HALL_ID,
                    },
                });
                dispatch(ArticlesAction.setArticlesKiosk(response.articles));
                return Promise.resolve(response.articles);
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };

    static fetchArticleGroups = () => {
        return dispatch => {
            return ajax.get("/articles/listGroups", {}).then(r => {
                dispatch(ArticlesAction.setArticleGroups(r.article_groups));
                return r.article_groups;
            });
        };
    };

    static setArticles = (articles: Article[]): ArticlesReducerSetArticlesAction => {
        return createAction(ArticlesAction.SET_ARTICLES, articles);
    };

    static setArticlesKiosk = (articles: Article[]): ArticlesReducerSetArticlesKioskAction => {
        return createAction(ArticlesAction.SET_ARTICLES_KIOSK, articles);
    };

    static setArticleGroups = (articleGroups: ArticleGroup[]): ArticlesReducerSetArticleGroupsAction => {
        return createAction(ArticlesAction.SET_ARTICLE_GROUPS, articleGroups);
    };
}

export default ArticlesAction;
